// extracted by mini-css-extract-plugin
export default {"BackLink":"BackLink_BackLink__FRVPz","kale":"BackLink_kale__8EjqQ","white":"BackLink_white__a32CG"};